/**
 * ResponseCode
 */
export const RESPONSE_CODE_UNAUTHORIZED = 403
export const RESPONSE_CODE_SUCCESS = 200
export const RESPONSE_CODE_GENERATE_URL_SUCCESS = 201

//export const TOKEN = "mickybominaung"
export const TOKEN = 'mickymouse'

export const STUDIO_DESC = "An entry unit for first time property investors. Have you ever thought of having the empowerment to purchase your first home? This is the best unit for you. The unit is configure to suit an aspiring working professional, with ambitions to climb that career ladder while having a safety net of a sound investment. And we understand, it’s not all about work, you need to have your down time and hang out with your favorite people. We want to give the best of both world to you, the studio unit is designed to accommodate, 2 persons living, and an ample living space and an open kitchen concept for you to entertain in the comfort of your home.";
export const ONE_BED_ROOM_DESC = "Have you recently gotten married? Are you planning for your first bundle of joy. This is the unit for you. The one bed room unit, is designed to provide young families with privacy but also ample space to enjoy the company of friends and family. It is also carefully curated so that the corridors and the doorways will not restrict free movement.";
export const TWO_BED_ROOM_DESC = "It’s always great joy to welcome a new baby, as you are expecting or expanding your family, this unit is perfect for you. The two bed unit provides enough room for your young children to study and play, while also giving enough space for parents to enjoy alone times. Cozy up to this apartment and grow with Yoma Land.";
export const THREE_BED_ROOM_DESC = "As your kids are getting older and needing spaces of their own, it always nice to give them their much needed space but also be within a watchful distance. This unit is perfect for a larger family. With windows all around, the apartment provides natural sun lights in all the bedroom. The apartment is designed to house a growing family. ";

export const STUDIO_IMAGE = [
    'https://cdn.yomastrategic.net/cityloft/clus/cl-studio.jpg',
    'https://cdn.yomastrategic.net/cityloft/clus/cl-studio-simple-1.jpg',
    'https://cdn.yomastrategic.net/cityloft/clus/cl-studio-simple-2.jpg'
]


export const ONE_BR_IMAGE = [
    'https://cdn.yomastrategic.net/cityloft/clus/cl-one-bathroom.jpg',
    'https://cdn.yomastrategic.net/cityloft/clus/cl-onebed-room-simple-1.jpg',
    'https://cdn.yomastrategic.net/cityloft/clus/cl-onebed-room-simple-2.jpg',
    'https://cdn.yomastrategic.net/cityloft/clus/cl-onebed-room-simple-3.jpg'
]

export const TWO_BR_IMAGE = [
    'https://cdn.yomastrategic.net/cityloft/clus/cl-two-bathroom.jpg',
    'https://cdn.yomastrategic.net/cityloft/clus/cl-twobed-room-simple-2.jpg',
    'https://cdn.yomastrategic.net/cityloft/clus/cl-twobed-room-simple-4.jpg',
    'https://cdn.yomastrategic.net/cityloft/clus/cl-twobed-room-simple-1.jpg',
    'https://cdn.yomastrategic.net/cityloft/clus/cl-twobed-room-simple-3.jpg',
    
]

export const THREE_BR_IMAGE = [
    'https://cdn.yomastrategic.net/cityloft/clus/cl-three-bathroom-A.jpg',
    'https://cdn.yomastrategic.net/cityloft/clus/cl-three-bathroom-B.jpg',
    'https://cdn.yomastrategic.net/cityloft/clus/cl-threeddbed-room-simple-1.jpg',
    'https://cdn.yomastrategic.net/cityloft/clus/cl-threeddbed-room-simple-2.jpg',
    'https://cdn.yomastrategic.net/cityloft/clus/cl-threeddbed-room-simple-3.jpg',
    'https://cdn.yomastrategic.net/cityloft/clus/cl-threeddbed-room-simple-4.jpg'
]

export const UNIT_VR_LINKS = [
    "https://my.matterport.com/show/?m=yN9s9aKGhBZ", //studio
    "https://my.matterport.com/show/?m=qTFRm2Ff4KS", // T1
    "https://my.matterport.com/show/?m=2gJtz7cDMZd", //T2
    "https://my.matterport.com/show/?m=Lvp1KdUQ592" //T3
]